module.exports = __webpack_public_path__ + "img/安全产品示例图_6.a1433e6a.png";